import { Button, Image, type ButtonProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/**
 * The one way to fix every "Meta Ads missing" state in the boost flow: the
 * integrations settings, where the Business Login dialog grants ad access. The
 * Meta mark names the account to connect, which the wording alone does not.
 */
export function ConnectMetaAdsButton(props: Omit<ButtonProps, 'onClick'>) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button
      alignSelf="flex-start"
      size="sm"
      variant="outline"
      colorPalette="primary"
      onClick={() => navigate('/settings/integrations')}
      {...props}
    >
      <Image src="/images/integrations/meta.svg" boxSize="16px" alt="" />
      {t('mentions.boost.connectMetaAds')}
    </Button>
  );
}

export default ConnectMetaAdsButton;
